
export default {
    LOGIN: {
        TITLE: 'Login',
        MSG: 'Access to your wallet.',
        EMAIL: 'ID',
        PASSWORD: 'Password',
        LOGIN: 'Login',
        SIGN_UP: 'Sign up',
        FORGOT_PASSWORD: 'Forgot password?',
        CONFIRM_PASSWORD: 'Confirm the password',
        CREATE_ACCOUNT: 'Create account',
        ALREADY_ACCOUNT_LOGIN: 'Already have an account? Login',
        REMEMBER_ME: 'Remember me',
    },
    CREDENTIALS: {
        TITLE: 'My credentials',
        SEARCH: 'Search...'
    },
    RECEIVE_CREDENTIALS: {
        CONFIRM_TITLE: 'Connection request',
        CONFIRM_CONNECTION_WITH: 'Confirm connection with',
        CONFIRM: 'Confirm',
        REJECT: 'Reject',
        RECEIVED_CREDENTIALS_TITLE: 'Received credentials',
        RECEIVED_CREDENTIALS_SUBTITLE: 'Click "Accept" to add the credential(s) to your wallet',
        ACCEPT: 'Accept'
    },
    ISSUANCE_INITIATION: {
        TITLE: 'Issuance initiation',
        SUBTITLE: 'A credential issuance request has been initiated',
        OFFERED_CREDENTIALS: 'Offered credentials',
        SUBJECT_DID: 'Subject DID',
        USER_PIN: 'User PIN'
    },
    ADD_CREDENTIAL: {
        TITLE: 'Add credential'
    },
    BACK: 'Back',
    MENU: {
        CREDENTIALS: 'Credentials',
        NFTS: 'NFTs',
        CONNECTIONS: 'Connections',
        SETTINGS: 'Settings',
        LOGOUT: 'Logout'
    },
    CREDENTIAL: {
        HASH:'Hash',
        ID: 'Credential Id',
        TITLE: 'Title',
        ISSUER: 'Issuer',
        STATUS: 'Status',
        ISSUED_ON: 'Issued on',
        EXPIRE: 'Expire',
        VALID_FROM: 'Valid from',
        FIRST_NAME: 'First name',
        GIVEN_NAME: 'Given name',
        LAST_NAME: 'Last name',
        FAMILY_NAME: 'Family name',
        GENDER: 'Gender',
        DATE_OF_BIRTH: 'Date of birth',
        ADDRESS: 'Address',
        STREET_ADDRESS: 'Street address',
        POSTAL_CODE: 'Postal code',
        LOCALITY: 'Locality',
        COUNTRY_NAME: 'Country name',
        FAMILY_STATUS: 'Family status',
        IDENTIFICATION_NUMBER: 'Identification number',
        DID: 'DID',
        NAME_AND_FAMILY_NAME_AT_BIRTH: 'Name and family name at birth',
        NATIONALITY: 'Nationality',
        PLACE_OF_BIRTH: 'Place of birth',
        PLACE_OF_BIRTH_COUNTRY: 'Country (place of birth)',
        DATE_OF_BIRTH_LOCALITY: 'Locality (place of birth)',
        PERSONAL_IDENTIFIER: 'Personal identifier',
        VACCINE_OR_PROFYLAXIS: 'Vaccine Or Prophylaxis',
        VACCINE_MEDICINAL_PRODUCT: 'Vaccine Medicinal Product',
        DOSE_NUMBER: 'Dose number',
        DATE_OF_VACCINATION: 'Date of vaccination',
        ADMINISTERING_CENTER: 'Administering center',
        COUNTRY_OF_VACCINATION: 'Country of vaccination',
        PROGRAM_NAME: 'Programm Name',
        DOMAIN: 'Domain',
        DELETE: 'Delete credential',
        GRADING_SCHEMA: 'Grading schema',
        TYPE: {
            VerifiableId: 'Verifiable ID document',
            VerifiableDiploma: 'Verifiable university diploma',
            VerifiableVaccinationCertificate: 'Verifiable certificate of vaccination',
            ProofOfResidence: 'Proof of residence',
            "gx:ParticipantCredential": "Gaia-X Participant Credential",
            VerifiableAttestation: "Verifiable attestation",
            EuropeanBankIdentity: "European bank identity",
            OpenBadgeCredential: "Open Badge V3",
            Europass: "Europass",
            "gx:LegalParticipant": "Gaia-X Legal Participant",
        },
        REGISTRATION_NUMBER: 'Registration number',
        LEGALLY_BINDING_NAME: 'Legally binding name',
        JURISDICTION: 'Jurisdiction',
        COUNTRY: 'Country',
        LEI_CODE: 'LEI code',
        ETH_ADDRESS: 'ETH Address',
        PARENT_ORGANIZATION: 'Parent organization',
        SUB_ORGANIZATION: 'Sub organization',
        LEARNING_ACHIEVEMENT: 'Learning achievement',
        ECTS_CREDIT_POINTS: 'ECTS credit points',
        DEFINITION: 'Definition',
        EQFL_LEVEL: 'EQFL level',
        NQFL_LEVEL: 'NQFL level',
        LOCATION: 'Location',
        STARTED_AT_TIME: 'Started at time',
        ENDED_AT_TIME: 'Ended at time',
        HOME_PAGE: 'Home page',
        ADDITIONAL_NOTE: 'Additional note',
        WORKLOAD: 'Workload',
        AWARDING_BODY: 'Awarding body',
        MAXIMUM_DURATION: 'Maximum duration',
        VOLUME_OF_LEARNING: 'Volume of learning',
        IS_PARTIAL_QUALIFICATION: 'Is Partial Qualification',
        LANGUAGE: 'Language',
        ALTERNATIVE_LABEL: 'Alternative label',
        SUPPLEMENTARY_DOCUMENT: 'Supplementary document',
        MODE: 'Mode',
        ISCEDF_CODE: 'ISCEDF code',
        IDENTIFIER: 'Identifier',
        HAS_PART: 'Has part',
        ACHIEVED: 'Achieved',
        WAS_DERIVED_FROM: 'Was derived from',
        WAS_INFLUENCED_BY: 'Was influenced by',
        WAS_AWARDED_BY: 'Was awarded by',
        SPECIFIED_BY: 'Specified by',
        LEARNING_OUTCOME: 'Learning outcome',
        AWARDING_OPPORTUNITY: 'Awarding opportunity',
        LEARNING_ACTIVITY_TYPE: 'Learning activity type',
        DIRECTED_BY: 'Directed by',
        GRADE: 'Grade',
        AWARDING_DATE: 'Awarding date',
        AWARDING_LOCATION: 'Awarding location',
        DESCRIPTION: 'Description',
        ISSUED_DATE: 'Issued date',
        ENTITLEMENT_TYPE: 'Entitlement type',
        LIMIT_ORGANIZATION: 'Limit organization',
        LIMIT_JURISDICTION: 'Limit jurisdiction',
        SCHEME_ID: 'Scheme Id',
        VALUE: 'Value',
        ASSESSED_BY: 'Assessed by',
        TEACHES: 'Teaches',
        ENTRY_REQUIREMENTS_NOTE: 'Entry requirements note',
        NAME: 'Name',
        LEARNING_OUTCOME_TYPE: 'Learning outcome type',
        REUSABILITY_LEVEL: 'Reusability level',
        RELATED_SKILL: 'Related skill',
        RELATED_ESCO_SKILL: 'Related ESCO skill',
        LEARNING_OPPORTUNITY_TYPE: 'Learning opportunity type',
        LEARNING_OUTCOME_DESCRIPTION: 'Learning outcome description',
        EDUCATION_SUBJECT: 'Education subject',
        CREDIT_POINTS: 'Credit points',
        EDUCATION_LEVEL: 'Education level',
        LEARNING_SETTING: 'Learning setting',
        TARGET_GROUP: 'Target group',
        LEARNING_ACTIVITY_SPECIFICATION: 'Learning activity specification',
        ASSESSMENT_SPECIFICATION: 'Assessment specification',
        ENTITLEMENT_SPECIFICATION: 'Entitlement specification',
        SPECIALIZATION_OF: 'Specialization of',
        EIDAS_LEGAL_IDENTIFIER: 'EIDAS legal identifier',
        REGISTRATION: 'Registration',
        PREFERRED_NAME: 'Preferred name',
    },
    NFTS: {
        TITLE: 'My NFTs',
        SEARCH: 'Search',
        ADJUST_MODAL: {
            TITLE: 'NFT Settings',
            APPLYING_CHANGES: 'Applying Changes'
        },
    },
    NFT: {
        CONTRACT_ADDRESS: 'Contract address',
        TOKEN_ID: 'Token ID',
        TOKEN_STANDARD: 'Token standard',
        BLOCKCHAIN: 'Blockchain',
        NAME: 'Name',
        DESCRIPTION: 'Description'
    },
    CREDENTIAL_SUBJECT: {
        TYPE: "Credential Subject Type",
        ID: "Credential Subject ID",
    },
    ISSUER: {
        TYPE: "Issuer Type",
        ID: "Issuer ID",
        URL: "Issuer URL"
    },
    ACHIEVEMENT: {
        TYPE: "Achievement Type",
        URL: "Achievement Url",
        NAME: "Achievement Name",
        DESCRIPTION: "Achievement Description"
    },
    CRITERIA: {
        TYPE: "Criteria Type",
        NARRATIVE: "Criteria Narrative"
    },
    CREDENTIAL_SCHEMA:{
        ID: "Credntial Schema ID",
        TYPE: "Credential Schema Type"
    },
    QR: {
        SCAN_QR_TITLE: "Scan QR code",
        SCAN_QR_TIP: "Start credential issuance or presentation by scanning a QR code"
    }
}
